import React from "react";
import ProfileCard from "../components/ProfileCard";
import profilesData from "../data/profiles.json";
import { useEffect } from "react";

const Kemper: React.FC = () => {
  const kemperProfiles = profilesData.filter(
    (profile) => profile.type === "kemper"
  );
  useEffect(() => {
    // Set the background color of the main div when the component mounts
    const mainDiv = document.getElementById("main");
    if (mainDiv) {
      mainDiv.classList.add("bg-emerald-900"); // Add Tailwind CSS class
    }

    // Reset the background color when the component unmounts
    return () => {
      if (mainDiv) {
        mainDiv.classList.remove("bg-emerald-900"); // Remove Tailwind CSS class
      }
    };
  }, []); // Empty dependency array: Runs only on mount and unmount

  return (
    <div className="container mx-auto p-8 text-white max-w-[1280px]">
      <section className="py-5 text-center">
        <h1 className="text-4xl md:text-6xl  lg:text-8xl font-bold  mb-0 lg:mb-20">
          Kemper Profiles
        </h1>
        <p className="opacity-70 mt-4 text-xl lg:text-xl">
          Legendary Mesa & Diezel Kemper Profiles. Explore our premium Kemper
          Profiles, capturing the iconic tones of Mesa Boogie and Diezel amps.
          Recreate sounds from Dream Theater albums, SRV's 'Texas Flood,' and
          more. Discover vintage Mark IIA, modern Mark V 35, and powerful
          Einstein tones. Free profile included. Elevate your Kemper experience
          today.
        </p>
      </section>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
        {kemperProfiles.map((profile) => (
          <ProfileCard key={profile.id} profile={profile} />
        ))}
      </div>
      <section className="mt-8 text-center max-w-[800px] mx-auto">
        <p className="text-sm opacity-50 ">
          PWC Profiles is not affiliated, associated, or in any way connected
          with the owners of the amplifier brands mentioned. All trademarks and
          copyrights belong to their respective owners. The use of these names
          is purely for descriptive and comparative purposes in the context of
          Kemper Profiles and Tonex models, which aim to replicate the sonic
          qualities of the original amplifiers.
        </p>
      </section>
    </div>
  );
};

export default Kemper;
